<mat-expansion-panel [expanded]="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <h6>{{ projectTitle }}</h6>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div fxLayout="column" fxLayout.xs="column">
    <mat-horizontal-stepper
      #stepper
      [(selectedIndex)]="selectedIndex"
      (selectionChange)="selectionStepChange($event)"
    >
      <mat-step>
        <ng-template matStepLabel>
          <div id="siteCreationId"></div>
          <span matTooltip="Site Creation">Site Creation</span>
        </ng-template>
        <app-site-creation></app-site-creation>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>
           
          <div id="connectionDetailsId"></div>
          <span matTooltip="Connection Details">Connection Details</span>
        </ng-template>
        <app-connection-details></app-connection-details>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>
          <div id="shiftDetailsId"></div>
          <span matTooltip="Shift Details"></span>Shift Details
        </ng-template>
        <app-shift-details></app-shift-details>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>
          <div id="processAndLoadDetailsId"></div>
          <span matTooltip="Process and Load Details"></span>Process and Load
          Details</ng-template
        >
        <app-process-and-load-details></app-process-and-load-details>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>
          <div id="groupsConfigId"></div>
          <span matTooltip="Report Groups Configuration"></span>Report Groups
          Configuration</ng-template
        >
        <app-report-group></app-report-group>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>
          <div id="reservesAndSourcesId"></div>
          <span matTooltip="Reserves And Sources"></span>Reserves And
          Sources</ng-template
        >
        <app-reserves-and-sources></app-reserves-and-sources>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>
          <div id="alertsConfigId"></div>
          <span matTooltip="Alerts Configuration"></span>Alerts
          Configuration</ng-template
        >
        <app-alerts-configuration></app-alerts-configuration>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>
          <div id="widgetsConfigId"></div>
          <span matTooltip="Widget Configuration"></span>Widget
          Configuration</ng-template
        >
        <app-widget-configuration></app-widget-configuration>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>
          <div id="reportConfigId"></div>
          <span matTooltip="Report Configuration"></span>Report
          Configuration</ng-template
        >
        <app-report-configuration></app-report-configuration>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>
          <div id="dataAcquisitionLayoutId"></div>
          <span matTooltip="Data Acquisition Layout"></span>Data Acquisition
          Layout</ng-template
        >
        <app-data-acquisition-layout></app-data-acquisition-layout>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>
          <div id="treeConfigId"></div>
          <span matTooltip="Tree Configuration"></span>Tree
          Configuration</ng-template
        >
        <app-tree-configuration></app-tree-configuration>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>
          <div id="clickAndNavigateId"></div>
          <span matTooltip="Click and Navigation Details"></span>Click and
          Navigation Details</ng-template
        >
        <app-click-and-navigation-details></app-click-and-navigation-details>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</mat-expansion-panel>
